import { SvgIconComponent } from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

import {
  LocalMallIcon,
  CardGiftcardIcon,
  SavingsOutlinedIcon,
  PaidOutlinedIcon,
  ExternalFulfillmentIcon,
} from '@occc-app/design-system';
import { AwardType } from '@occc-app/offerHelpers/types';

import { OfferType } from './types';

// TODO: move this type up in hierarchy (it should be used on every campaign component)

type OfferTypeItem = {
  type: OfferType;
  title: string;
  description: string;
  icon: SvgIconComponent | React.ComponentType<SvgIconProps>;
};

export const offerTypes: OfferTypeItem[] = [
  {
    type: OfferType.ProductPurchase,
    title: 'Product Purchase',
    description:
      'Provide points or awards when members purchase specific products in a single transaction',
    icon: LocalMallIcon,
  },
  {
    type: OfferType.SpendBonus,
    title: 'Spend Bonus',
    description: 'Provide bonus points or awards for all money spent over a threshold',
    icon: CardGiftcardIcon,
  },
  {
    type: OfferType.BaseEarn,
    title: 'Base Earn',
    description: 'Provide members points on all products every time they visit your business',
    icon: SavingsOutlinedIcon,
  },
  {
    type: OfferType.BaseEligibleEarn,
    title: 'Base Eligible Earn',
    description:
      'Provide members points only on eligible products every time they visit your business',
    icon: PaidOutlinedIcon,
  },
  {
    type: OfferType.ExternalFulfillment,
    title: 'External Fulfillment',
    description: 'Provide benefits when members take actions outside of Open Commerce',
    icon: ExternalFulfillmentIcon,
  },
];

type OfferAwardType = AwardType.AwardPoints | AwardType.AwardPointsPer | AwardType.AwardNullable;

export const offerTypeToAwardTypeMap: Record<OfferType, OfferAwardType> = {
  [OfferType.ProductPurchase]: AwardType.AwardPoints,
  [OfferType.SpendBonus]: AwardType.AwardPoints,
  [OfferType.BaseEarn]: AwardType.AwardPointsPer,
  [OfferType.BaseEligibleEarn]: AwardType.AwardPointsPer,
  [OfferType.ExternalFulfillment]: AwardType.AwardNullable,
};

export const minimumPurchaseApplicableOfferTypes: OfferType[] = [
  OfferType.ProductPurchase,
  OfferType.BaseEarn,
  OfferType.BaseEligibleEarn,
];
